import { render } from "./BigCard.vue?vue&type=template&id=7ac0c8d3"
import script from "./BigCard.vue?vue&type=script&lang=js"
export * from "./BigCard.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__